import { MenuState } from "./states/MenuState";
import { LoadingState } from "./states/LoadingState";

import { Renderer }      from "./core/Renderer";
import { CameraManager } from "./core/CameraManager";
import { InputManager }  from "./core/InputManager";
import { AssetLoader }   from "./core/AssetLoader";
import { EffectManager } from "./core/EffectManager";
import { SFXManager } from "./core/SFXManager.js";
import { SettingsMenu }  from "./SettingsMenu.js";
import { UserData } from "./user/UserData.js";
import { AuthManager } from "../Auth/AuthManager.js";

export class StateManager {

    constructor() {
        this.state = null;

        this.Renderer      = new Renderer();
        this.CameraManager = new CameraManager(this.Renderer.Camera, this.Renderer.Canvas);
        this.InputManager  = new InputManager(this.Renderer.Canvas);
        this.AssetLoader   = new AssetLoader();
        this.EffectManager = new EffectManager();
        this.SFX           = new SFXManager();

        this.Auth = new AuthManager();
        

        // Load volume preference then init sounds
        this.SFX.loadVolume();
        this.SFX.init();

        // Settings menu — shared across all states
        this.Settings = new SettingsMenu(this.SFX);

        // Wire the settings button (exists in MenuOverlay)
        document.getElementById('settings')?.addEventListener('click', () => {
            this.Settings.show();
        });

        // User progress — load immediately from localStorage
        this.UserData = new UserData(this.Auth).loadSync();

        // Persists across states — read by RoundState
        this.loadout           = [];
        this.selectedLevel     = null;
        this.selectedLevelData = null;

        this.changeState(new LoadingState(this));
    }

    Animate(deltaTime) {
        if (this.state) {
            this.state.Animate(deltaTime);
        }

        this.CameraManager.update(deltaTime);
        this.EffectManager.update(deltaTime);
        this.Renderer.Render();
        this.InputManager.clearFrameInputs();
    }

    changeState(state) {
        if (this.state) {
            this.state.Exit();
        }

        this.EffectManager.clear();

        this.state = state;
        this.state.Enter();
    }
}